module.exports = __webpack_public_path__ + "img/fondo-login-logo-dinapsis.a86be900.svg";